import { z } from "zod";

export enum ProjectGovernorCheckTypes {
  DOCUMENTATION = "documentation",
  TESTS = "tests",
  MODEL = "model",
  FILE_STRUCTURE = "file_structure",
}

export enum ProjectGovernorAllowedFiles {
  Manifest = "Manifest",
  Catalog = "Catalog",
}

export interface ProjectGovernorCheckFormValues {
  description: string;
  type: ProjectGovernorCheckTypes;
}

export interface ProjectGovernorCheckValidateResponse {
  name: string;
  description: string;
}

export interface ProjectGovernorCheckConfirmationResponse {
  ok: boolean;
}

export const ProjectGovernorCheckSchema = z.object({
  name: z.string(),
  alias: z.string(),
  type: z.enum(Object.values(ProjectGovernorCheckTypes) as [string, ...string[]]),
  description: z.string(),
  files_required: z.array(
    z.enum(Object.values(ProjectGovernorAllowedFiles) as [string, ...string[]])
  ),
  config: z.record(z.unknown()),
});

export interface ProjectGovernorCheck extends z.infer<typeof ProjectGovernorCheckSchema> {
  id: string;
}
